const stats = [
  { label: "Events Managed", value: "25+" },
  { label: "Cities Covered", value: "8+" },
  { label: "Years of Experience", value: "2+" },
];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="section">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-14 items-center">
        <div className="fade-up">
          <div className="relative w-full max-w-md aspect-[4/5] rounded-3xl overflow-hidden border border-[var(--ee-border)]">
            <img
              data-testid="about-image"
              src="/about/founder.jpg"
              alt="Elite Eventz founder"
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover"
              draggable={false}
            />
            <div
              className="absolute inset-0 pointer-events-none"
              style={{
                background:
                  "linear-gradient(180deg, rgba(0,0,0,0) 60%, rgba(0,0,0,0.55) 100%)",
              }}
            />
          </div>
        </div>

        <div className="fade-up">
          <div className="eyebrow mb-5">About Elite Eventz</div>
          <h2 className="section-title">
            {/* Short dash used here to match the brand copy style and avoid the heavy double-dash look. */}
            We don't just plan events –{" "}
            <span className="gold-text-gradient italic">we craft moments</span>
          </h2>

          <div className="mt-6 glass rounded-2xl p-5 text-sm text-neutral-300 leading-relaxed">
            <p className="text-[var(--ee-gold)] font-medium tracking-[0.18em] text-xs uppercase mb-2">
              Company Description
            </p>
            <p>
              Founded by Shlok Joshi and Arnav Daithankar, Elite Eventz was born from a shared passion for creating experiences that go beyond the ordinary. What started as a vision to redefine event management has grown into a brand dedicated to delivering exceptional moments through creativity, precision and flawless execution. We believe that every event, whether it&apos;s a vibrant cultural festival, an electrifying concert, a corporate gathering, a competitive sports tournament, or a large-scale community celebration, deserves to tell a unique story and leave a lasting impression.
            </p>
            <p className="mt-4">
              At Elite Eventz, we don&apos;t see ourselves as event organizers. We see ourselves as experience creators. Every detail, from the initial concept to the final applause, is thoughtfully planned to reflect our clients&apos; vision while exceeding every expectation. Our approach combines innovative ideas, meticulous planning and seamless execution to transform ordinary occasions into unforgettable celebrations.
            </p>
            <p className="mt-4">
              Driven by a commitment to quality, professionalism and innovation, we strive to create environments where people connect, celebrate and build memories that last a lifetime. Every event we deliver is a reflection of our passion for excellence and our belief that meaningful experiences have the power to inspire, unite, and leave a lasting legacy. At Elite Eventz, our philosophy is simple: an event may last for a day, but the memories it creates should stay with you forever.
            </p>
          </div>

          <div className="mt-10 grid grid-cols-2 gap-4">
            {stats.map((s) => (
              <div
                key={s.label}
                data-testid={`about-stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="glass rounded-2xl p-5 card-hover"
              >
                <div className="font-display text-4xl gold-text-gradient">
                  {s.value}
                </div>
                <div className="text-xs uppercase tracking-[0.22em] text-neutral-400 mt-1">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
